import axios from 'axios';



/**
 * 获取创业补贴地区数据
 * @returns {json}
 */
export const getPlace = params => {
  return axios.get('/yongpai-service/api/subsidy/get_place',{params : params});
};

/**
 * 获取创业类型
 * @returns {json}
 */
export const getStartupType = params => {
  return axios.get('/yongpai-service/api/subsidy/get_startup_type',{params : params});
};

/**
 * 保存创业就业补贴
 * @returns {json}
 */
export const saveStartupSubsidy = params => {
  return axios.get('/yongpai-service/api/subsidy/saveStartupSubsidy',{params : params});
};

/**
 * 查询创业补贴信息
 * @returns {json}
 */
export const getSubsidyInfo = params => {
  return axios.get('/yongpai-service/api/subsidy/get_subsidy_info',{params : params});
};

/**
 * 获取公共职介信息分类
 * @returns {json}
 */
export const getPublicJobs = params => {
  return axios.get('/yongpai-service/api/subsidy/get_public_jobs',{params : params});
};

/**
 * 获取公共职介信息列表
 * @returns {json}
 */
export const getBriefJobs = params => {
  return axios.get('/yongpai-service/api/subsidy/get_brief_jobs',{params : params});
};

/**
 * 条件查询公共职介信息列表
 * @returns {json}
 */
export const getFindJobs = params => {
  return axios.get('/yongpai-service/api/subsidy/find_jobs',{params : params});
};

/**
 * 获取人员类别
 * @returns {json}
 */
export const getUserType = params => {
  return axios.get('/yongpai-service/api/subsidy/get_user_type',{params : params});
};

/**
 * 查询高校就业补贴信息
 * @returns {json}
 */
export const getEmploymentSubsidy = params => {
  return axios.get('/yongpai-service/api/subsidy/get_employment_subsidy',{params : params});
};

/**
 * 提交高校补贴
 * @returns {json}
 */
export const saveEmploymentSubsidy = params => {
  return axios.get('/yongpai-service/api/subsidy/save_employment_subsidy',{params : params});
};

/**
 * 稳岗查询
 * @returns {json}
 */
export const saveEnterpriseSubsidy = params => {
  return axios.get('/yongpai-service/api/subsidy/save_enterprise_subsidy',{params : params});
};









// WEBPACK FOOTER //
// ./src/api/service/index.js